import React from 'react';

import UIStatusDialog from 'components/UIStatusDialog.js';

// The toast stack every view keeps in state as `statuses`. Each entry is
// {key, title, message, status}; onClose receives the dialog's props, as UIStatusDialog sends them.
const StatusDialogs = ({ statuses, onClose }) => (
  <div>
    {statuses.map(status => (
      <UIStatusDialog key={status.key} status={status} closeDialog={onClose} />
    ))}
  </div>
);

export default StatusDialogs;
